
import { defineComponent, PropType } from "vue";
import { AP, DeviceCount, DeviceDetection } from "@/domain/model";
import CongestionLevel from "@/components/CongestionLevel.vue";
import CongestionLevelIcon from "@/components/CongestionLevelIcon.vue";
import Devices, { DeviceDetectionRowData } from "@/components/Devices.vue";
import Chart from "@/components/Chart.vue";
import ApexChart from "vue3-apexcharts";

// type DeviceDetectionMap = {
//   [mac: string]: DeviceDetectionRowData[];
// };

// type CongestionLevelMap = {
//   [mac: string]: number;
// };

// type DeviceCountMap = {
//   [mac: string]: DeviceCount[];
// };

export default defineComponent({
  props: {
    ap: {
      type: Object as PropType<AP>,
      required: true,
    },
    aggrigationUnit: {
      type: String,
      default: "minute",
    },
    congestionLevel: {
      type: Number,
      required: true,
      default: 0,
    },
    deviceDetections: {
      type: Array as PropType<DeviceDetectionRowData[]>,
      required: true,
      default: () => {
        return [];
      },
    },
    deviceCountLog: {
      type: Array as PropType<DeviceCount[]>,
      required: true,
      default: () => {
        return [];
      },
    },
  },

  computed: {
    sortedDeviceDetections(): DeviceDetectionRowData[] {
      if (this.deviceDetections === undefined) {
        return [];
      }
      return [...this.deviceDetections].sort((a, b) => {
        const aStay = a?.stay ?? 0;
        const bStay = b?.stay ?? 0;
        if (aStay > bStay) {
          return -1;
        } else if (aStay < bStay) {
          return 1;
        }
        const aRSSI = a?.rssi ?? Number.MIN_SAFE_INTEGER;
        const bRSSI = b?.rssi ?? Number.MIN_SAFE_INTEGER;
        if (aRSSI > bRSSI) {
          return -1;
        } else if (aRSSI < bRSSI) {
          return 1;
        }
        return 0;
      });
    },

    apexchartData(): any {
      return [
        {
          name: "stay",
          data: this.deviceCountLog.map((dc: DeviceCount) => {
            return [dc.timestamp, dc.stayCount];
          }),
        },
        {
          name: "non-stay",
          data: this.deviceCountLog.map((dc: DeviceCount) => {
            return [dc.timestamp, dc.nonstayCount];
          }),
        },
      ];
    },

    apexchartOptions(): any {
      var xLabelFormat = "HH:mm";
      switch (this.aggrigationUnit) {
        case "minute":
          xLabelFormat = "HH:mm";
          break;

        case "hour":
          xLabelFormat = "HH:mm";
          break;

        case "day":
          xLabelFormat = "M/d";
          break;
      }

      return {
        chart: {
          type: "bar",
          stacked: true,
        },
        xaxis: {
          type: "datetime",
          categories: this.deviceCountLog.map((dc: DeviceCount) => {
            return dc.timestamp;
          }),
          labels: {
            datetimeUTC: false,
            format: xLabelFormat,
          },
        },
        annotations: {
          position: "front",
          yaxis: [
            {
              y: this.ap.congestionBorder1,
              borderColor: "#FF8800",
              label: {
                text: "MIDDLE",
                borderColor: "#FF8800",
                textAnchor: "start",
                position: "left",
                style: {
                  color: "#fff",
                  background: "#FF880088",
                },
              },
            },
            {
              y: this.ap.congestionBorder2,
              borderColor: "#FF0000",
              label: {
                text: "HIGH",
                borderColor: "#FF0000",
                textAnchor: "start",
                position: "left",
                style: {
                  color: "#fff",
                  background: "#FF000088",
                },
              },
            },
          ],
        },
        tooltip: {
          x: {
            show: true,
            format: xLabelFormat,
          },
        },
      };
    },
  },

  methods: {
    onChangeAggregationUnit(unit: string) {
      this.$emit("changeAggregationUnit", { ap: this.ap, unit });
    },

    onEdit() {
      this.$emit("edit", { ap: this.ap });
    },

    onDelete() {
      this.$emit("delete", { ap: this.ap });
    },
  },

  components: {
    CongestionLevel,
    CongestionLevelIcon,
    Devices,
    Chart,
    ApexChart,
  },
});
